import store from "@/app/app-state";
import PrivateLayout from "@/app/layouts/Private.vue";
import { Route } from "vue-router";
import Indexation from "./indexation/Indexation.vue";

const indexationRoutes = [
  {
    path: "/indexation",
    meta: {
      type: "module",
      breadcrumb: [
        {
          text: "Facturation",
        },
      ],
      iconClass: "mdi-invoice-text",
    },
    component: PrivateLayout,

    children: [
      {
        path: "indexation",
        name: "indexation",
        component: Indexation,
        meta: {
          breadcrumb: [
            {
              text: "Indexation",
              to: "/facturation/indexation",
            },
          ],
          rightName: "_FACTURATION_INDEXATION", // Ce droit ne doit pas etre créé dans le rightManager
          type: "subModule",
          iconClass: "mdi-home-battery-outline",
          featureFlipping: { key: "facturationIndexation" },
        },
        beforeEnter: (to: Route, _from: Route, next: any) => {
          // page autorisé seulement si administrateur
          if (
            store.state.userContext.isAdministrator ||
            (store.state.userContext.rights.includes(to.meta?.rightName) &&
              store.state.userContext.functionalities.includes(to.meta?.rightName))
          ) {
            next();
          } else {
            next("/Unauthorized", { replace: true, name: "page-unauthorized" });
          }
        },
      },
    ],
  },
];

export default indexationRoutes;
